import { PageHeader } from '@/layout/AppShell'
import { Card } from '@/components/ui/Card'
import { EmptyState, Skeleton } from '@/components/ui/States'
import { IconDoc } from '@/components/Icon'

/** Esqueleto exibido enquanto o chunk de uma tela lazy é baixado. */
export function CarregandoTela() {
  return (
    <Card>
      <div className="space-y-3 p-4" aria-busy aria-label="Carregando tela">
        <Skeleton className="h-5 w-56" />
        <Skeleton className="h-3 w-80" />
        <Skeleton className="h-48" />
      </div>
    </Card>
  )
}

/** Placeholder das telas ainda não construídas. Some conforme o projeto avança. */
export function EmDesenvolvimento({ nome }: { nome: string }) {
  return (
    <>
      <PageHeader title={nome} />
      <Card>
        <EmptyState
          icon={<IconDoc className="size-5" />}
          title="Tela ainda não construída"
          description="Já foi mapeada e especificada. Entra na fila de construção conforme o plano do redesign."
        />
      </Card>
    </>
  )
}
